export default {
  roles: [],
  roleInfos: null
}
